import * as React from 'react';
import { colors } from '../../../index';

const IconLock = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 10 11",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.068 3.605v-.45A3.156 3.156 0 004.918 0a3.156 3.156 0 00-3.15 3.154v.45c-.745 0-1.35.607-1.35 1.353v4.506c0 .745.605 1.352 1.35 1.352h6.3c.744 0 1.35-.607 1.35-1.352V4.957c0-.746-.606-1.352-1.35-1.352zm-5.4-.45A2.254 2.254 0 014.918.9c1.24 0 2.25 1.01 2.25 2.253v.45h-4.5v-.45zm5.85 6.308a.45.45 0 01-.45.45h-6.3a.45.45 0 01-.45-.45V4.957a.45.45 0 01.45-.45h6.3a.45.45 0 01.45.45v4.506z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.881 5.19c-.74 0-1.342.609-1.342 1.357 0 .59.375 1.087.895 1.275v.762c0 .25.2.452.447.452a.45.45 0 00.448-.452v-.762c.52-.188.895-.686.895-1.275 0-.748-.602-1.357-1.343-1.357zm0 1.81a.45.45 0 01-.447-.453c0-.25.2-.452.447-.452a.45.45 0 01.448.452.45.45 0 01-.448.453z"
  })));
};

export default IconLock;